import React, { useState } from 'react'
import {
  Box,
  Button,
  HStack,
  Text,
  useToast,
  Icon,
  InputGroup,
  Input,
  InputRightElement,
} from '@chakra-ui/react'
import { FaCopy, FaEye, FaEyeSlash } from 'react-icons/fa'

interface DeployCommandCopyProps {
  apiKey: string
}
const DeployCommandCopy: React.FC<DeployCommandCopyProps> = ({ apiKey }) => {
  const toast = useToast()
  const [showCommand, setShowCommand] = useState(false)
  const deployCommand = `LIBRE_API_KEY=${apiKey} bash -c "$(curl -L https://storage.googleapis.com/libre_alpha_public/script.sh)"`

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(deployCommand)
      toast({
        title: 'Copied to clipboard',
        status: 'success',
        duration: 2000,
        isClosable: true,
      })
    } catch (err) {
      toast({
        title: 'Failed to copy',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    }
  }

  const toggleShowCommand = () => {
    setShowCommand(!showCommand)
  }

  return (
    <Box
      p={4}
      borderWidth="1px"
      borderRadius="md"
      bg="gray.50"
      _hover={{ bg: 'gray.100' }}
    >
      <HStack justify="space-between">
        <InputGroup>
          <Input
            type={showCommand ? 'text' : 'password'}
            value={deployCommand}
            readOnly
            pr="4.5rem"
            fontFamily="monospace"
            fontSize="sm"
            bg="transparent"
            border="none"
            _focus={{ border: 'none' }}
            _hover={{ border: 'none' }}
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={toggleShowCommand}>
              <Icon as={showCommand ? FaEyeSlash : FaEye} />
            </Button>
          </InputRightElement>
        </InputGroup>
        <Button
          size="sm"
          variant="ghost"
          onClick={handleCopy}
          leftIcon={<Icon as={FaCopy} />}
        >
          Copy
        </Button>
      </HStack>
    </Box>
  )
}

export default DeployCommandCopy 